import React from "react";

import {
  Box,
  BoxProps,
  Button,
  IconCross,
  IconDownArrow,
  Text,
} from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

const PlainButton = styled(Button)`
  background-color: transparent;
  color: ${themeGet("colors.text")};
  min-width: 0 !important;
  line-height: 1;
  padding: 0px;
  border: none;
  top: 17px;
  position: absolute;
  &:hover:not(:disabled):not([disabled]) {
    background-color: transparent;
  }
  &:active {
    box-shadow: none;
  }
`;

const BackButton = styled(PlainButton)`
  left: 15px;
  padding: 15px 20px;
  margin: -15px -20px;
`;

const CloseButton = styled(PlainButton)`
  right: 32px;
  padding: 15px 20px;
  margin: -15px -20px;
`;

const BackArrow = styled(IconDownArrow)`
  transform: rotate(90deg);
  width: 10px;
  height: 5px;
`;

export type MenuHeaderProps = BoxProps & {
  title: string;
  level?: number;
  closeMenu?: () => void;
  onBackButtonClick?: () => void;
};

export const MenuHeader = ({
  title,
  level,
  closeMenu,
  onBackButtonClick,
  ...props
}: MenuHeaderProps) => (
  <Box position="relative" {...props}>
    <Text
      py="14px"
      my="0px"
      fontSize="base"
      lineHeight="24px"
      textAlign="center"
      fontWeight="medium"
    >
      {title}
    </Text>
    {closeMenu && (
      <CloseButton aria-label="Close button" onClick={closeMenu}>
        <IconCross width="11px" height="11px" color="secondary" />
      </CloseButton>
    )}
    {level && level > 1 && onBackButtonClick && (
      <BackButton aria-label="Back button" onClick={onBackButtonClick}>
        <BackArrow />
      </BackButton>
    )}
  </Box>
);
